module.exports = __webpack_public_path__ + "static/media/jump.c264143a.wav";